export default __webpack_public_path__ + "static/media/juice-fruit-product-r-mobile@3x.1ec67371.png";